import React from "react";
// import HomePage from "../components/Home/HomePage";
import Workspace from "../components/Home/Workspace";

function Home() {
  return (
    <div className="">
      {/* <HomePage /> */}
      <Workspace />
    </div>
  );
}

export default Home;
